import { ApiResponse,  } from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';
import { TypedMutationConfig } from '@/lib/react-query';
import { TTicket } from '../types/ticket.type';
import axios, { AxiosRequestConfig } from "axios";
import { API_URL } from "@/configs/api.config";
import authLocalStorage from "@/features/auth/_shared/utils/auth-localstorage";

  export type TDownloadCreateBulkTicketTemplateResponse = ApiResponse<TTicket>;
export type TDownloadCreateBulkTicketTemplateParams = {
  spaceId: string;
};
export const downloadCreateBulkTicketTemplate = async (params: TDownloadCreateBulkTicketTemplateParams): Promise<TDownloadCreateBulkTicketTemplateResponse> => {

  const url = `${API_URL}/space/bulk-create-ticket-template/${params.spaceId}`;

  const config: AxiosRequestConfig = {
    responseType: 'blob' as const,
    timeout: Infinity,
    headers: {
      Authorization: `Bearer ${authLocalStorage.getToken()}`,
    },
    
  };

  return axios.get(url, config);
};


/**
 * React Query Hooks
 */
type TUseDownloadCreateBulkTicketTemplateMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof downloadCreateBulkTicketTemplate>;
};

export const useDownloadCreateBulkTicketTemplateMutation = ({ mutationConfig }: TUseDownloadCreateBulkTicketTemplateMutationOptions) => {
  const { ...restConfig } = mutationConfig ?? {};

  return useMutation({
    mutationFn: downloadCreateBulkTicketTemplate,
    ...restConfig,
  });
};  
